module.exports = __webpack_public_path__ + "img/bg-download-section-1.d7dce41f.webp";